import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarketeqGoldMedal6 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5027 11.0015C11.2986 11.0015 12.0618 10.6854 12.6246 10.1226C13.1873 9.55987 13.5035 8.79662 13.5035 8.00077C13.5035 7.20491 13.1873 6.44166 12.6246 5.8789C12.0618 5.31615 11.2986 5 10.5027 5C9.70687 5 8.94361 5.31615 8.38086 5.8789C7.8181 6.44166 7.50195 7.20491 7.50195 8.00077C7.50195 8.79662 7.8181 9.55987 8.38086 10.1226C8.94361 10.6854 9.70687 11.0015 10.5027 11.0015Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.29095 11.5703L1.5 15.5621L4.53101 16.4623L6.41117 19.0031L9.23189 14.9821M16.7141 11.5703L19.5046 15.5616L16.4741 16.4618L14.5934 19.0026L11.7727 14.9816",
			stroke: "#A0A0A0",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7886 8.00023C17.7886 8.76074 17.1184 9.40075 16.898 10.0811C16.6781 10.7609 16.8284 11.6914 16.3982 12.2815C15.968 12.8716 15.0476 13.0017 14.5075 13.4419C13.9673 13.8822 13.5074 14.7023 12.8074 14.9322C12.1069 15.1622 11.3166 14.7219 10.5566 14.7219C9.79653 14.7219 8.98656 15.1521 8.30623 14.9322C7.62589 14.7119 7.1957 13.8616 6.60563 13.4419C6.01508 13.0218 5.09517 12.8716 4.66498 12.2815C4.23479 11.6909 4.39515 10.7811 4.16517 10.0811C3.93471 9.38058 3.22461 8.76074 3.22461 8.00023C3.22461 7.23972 3.89486 6.60019 4.11476 5.91986C4.33465 5.23953 4.18485 4.30953 4.61504 3.71946C5.04523 3.12939 5.96563 2.99927 6.5557 2.559C7.14577 2.11873 7.50586 1.29868 8.25581 1.0687C9.00624 0.838243 9.74659 1.27852 10.5066 1.27852C11.2667 1.27852 12.0766 0.848326 12.7574 1.0687C13.4373 1.2886 13.8675 2.1389 14.5075 2.559C15.1475 2.97911 16.018 3.12891 16.4481 3.71946C16.8783 4.31001 16.7185 5.21984 16.9484 5.91986C17.1784 6.61988 17.7886 7.2402 17.7886 8.00023Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMarketeqGoldMedal6;
